import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Button, Modal} from 'react-bootstrap';
import {DatePicker} from 'antd';
import 'dayjs/locale/he';
import locale from 'antd/es/date-picker/locale/he_IL';

const PopupCloseForm6101 = ({
                              isOpen,
                              onHide,
                              onDateSelect,
                              onSubmit
                            }) => {
  return (
    <Modal show={isOpen} onHide={onHide}>
      <div className={'p-6'}>
        <Modal.Title className={'text-primary text-center'}>
          <FormattedMessage
            id="userDetails-files-generate-pdf"
            defaultMessage="Generate PDF"
          />
        </Modal.Title>
        <Modal.Body>
          <div className="h3 text-center">
            <FormattedMessage
              id="userDetails-files-generate-pdf-text"
              defaultMessage="Generate PDF"
            />
          </div>
          <DatePicker
            className={'form-control d-flex mx-auto mb-4 w-150px'}
            placeholder={''}
            onChange={date => onDateSelect(date.$d)}
            locale={locale}
            format={'DD-MM-YYYY'}
            clearIcon={false}
            suffixIcon={false}
            showToday={false}
          />
        </Modal.Body>
        <div className={'d-flex justify-content-center'}>
          <Button
            variant="secondary"
            size="sm"
            onClick={onHide}
            className={'w-100px'}
          >
            <FormattedMessage
              id="userDetails-files-generate-pdf-close"
              defaultMessage="Close"
            />
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={onSubmit}
            className={'ml-8 w-100px'}
          >
            <FormattedMessage
              id="userDetails-files-generate-pdf-generate"
              defaultMessage="Generate PDF"
            />
          </Button>
        </div>
      </div>
    </Modal>
  );
};

PopupCloseForm6101.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onDateSelect: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default PopupCloseForm6101;

